/* Bloom More — "buy 2, get 1 free" mix & match funnel.
   Money never lives here: prices come from the Liquid JSON (live Shopify prices); the checkout price comes from the
   BLOOMMORE discount code, which the page applies and VERIFIES before it lets the customer continue (fail closed). */
(function () {
  'use strict';
  var SWATCH = { 'שחור': '#000', 'לבן': '#f4f4f4', 'קרם': '#e9dccb', 'כחול': '#1f3a72', 'תכלת': '#8fb8e0', 'אפור': '#8a8a8a', 'אפור כהה': '#4a4a4a', 'אפור בהיר': '#c9c9c9', 'בורדו': '#6b1f2c', 'ירוק': '#4c6b48', 'אדום': '#b3261e', 'ורוד': '#e6a7b7', 'מוקה': '#8b6b52', 'טורקיז': '#3aa6a0', 'סגול לילך': '#b8a1d9', 'כחול אוקיינוס': '#2b5f8e', 'קקאו': '#5c3d2e' };
  var SIZE_ORDER = ['XS', 'S', 'M', 'L', 'XL', '2XL', '3XL'];

  function money(agorot) { return '₪' + (agorot / 100).toLocaleString('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

  function init(root) {
    var dataEl = document.querySelector('script[data-bloom-more-products]');
    if (!dataEl) return;
    var products;
    try { products = JSON.parse(dataEl.textContent).filter(function (p) { return p && p.variants && p.variants.some(function (v) { return v.available; }); }); } catch (e) { return; }
    if (!products.length) return;
    var code = root.getAttribute('data-code') || 'BLOOMMORE';
    var $ = function (sel) { return root.querySelector(sel); };
    var box = $('[data-box]'), grid = $('[data-grid]'), giftGrid = $('[data-gift-grid]'), sizesEl = $('[data-sizes]');
    var nextBtn = $('[data-next]'), actionEl = $('[data-action]'), actionSum = $('[data-action-sum]'), errEl = $('[data-error]'), addingEl = $('[data-adding]');
    var steps = ['size', 'pick', 'gift'];
    var state = { step: 0, size: null, picks: [], gift: null };   // picks: [{product, color}] ; gift: {product, color}

    // ---- helpers ------------------------------------------------------------------------
    var sizes = [];
    products.forEach(function (p) { p.variants.forEach(function (v) { if (v.size && sizes.indexOf(v.size) < 0) sizes.push(v.size); }); });
    sizes.sort(function (a, b) { return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); });
    function colorsOf(p) { var out = []; p.variants.forEach(function (v) { if (v.color && out.indexOf(v.color) < 0) out.push(v.color); }); return out; }
    function variantFor(p, color, size) {
      return p.variants.find(function (v) { return v.available && (!v.size || v.size === size) && (!v.color || v.color === color); }) || null;
    }
    function anyVariantForSize(p, size) { return p.variants.some(function (v) { return v.available && (!v.size || v.size === size); }); }
    function firstColorFor(p, size) { var c = colorsOf(p).find(function (col) { return variantFor(p, col, size); }); return c || ''; }
    function priceOf(pick) { var v = variantFor(pick.product, pick.color, pick.size || state.size); return v ? v.price : pick.product.price; }
    function imageOf(pick) { var v = variantFor(pick.product, pick.color, pick.size || state.size); return (v && v.image) || pick.product.image; }
    function minPickPrice() { return Math.min.apply(null, state.picks.map(priceOf)); }
    function giftEligible(p) { return anyVariantForSize(p, state.size) && p.price <= minPickPrice(); }

    // ---- step 1: size wizard, one question at a time (same rule as the store's size finder page) -------
    var usualEl = $('[data-usual]'), monthChips = $('[data-month-chips]'), fitEl = $('[data-fit]');
    var finder = { usual: null, month: null, fit: null };
    try { var hand = JSON.parse(localStorage.getItem('bloom_size_handoff') || 'null'); if (hand && hand.size && sizes.indexOf(hand.size) > -1 && Date.now() - (hand.time || 0) < 864e5 * 30) finder.usual = hand.size; } catch (e) { /* ignore */ }
    function recommend() {
      if (!finder.usual) return null;
      var i = sizes.indexOf(finder.usual);
      if (finder.fit === 'relaxed') i++;
      if ((finder.month || 0) >= 8 && finder.fit !== 'close') i++;
      return sizes[Math.max(0, Math.min(sizes.length - 1, i))];
    }
    function setSize(s) {
      state.size = s;
      Array.prototype.forEach.call(sizesEl.children, function (c) { c.classList.toggle('is-selected', c.textContent === s); });
      state.picks = state.picks.filter(function (pk) { return anyVariantForSize(pk.product, s); }).map(function (pk) { pk.size = null; if (!variantFor(pk.product, pk.color, s)) pk.color = firstColorFor(pk.product, s); return pk; });
      if (state.gift && !giftEligible(state.gift.product)) state.gift = null;
      sync();
    }
    function enterFlow() {
      if (root.classList.contains('is-in')) return;
      root.classList.add('is-in');
      window.scrollTo({ top: Math.max(0, box.getBoundingClientRect().top + window.pageYOffset - 12), behavior: 'smooth' });
      track('enter');
    }
    function leaveFlow() { root.classList.remove('is-in'); showQ('usual'); window.scrollTo({ top: 0, behavior: 'smooth' }); }
    var Q_ORDER = ['usual', 'month', 'fit', 'calc', 'result'];
    function currentQ() { var a = root.querySelector('[data-wq].is-active'); return a ? a.getAttribute('data-wq') : 'usual'; }
    function goBack() {
      clearTimeout(state.autoNext); clearTimeout(state.autoPick); clearTimeout(state.autoAdd);
      if (state.step > 0) { show(state.step - 1, { noScroll: true }); if (state.step === 0) showQ('result'); return; }
      var q = currentQ();
      if (q === 'usual') { leaveFlow(); return; }
      if (q === 'result' || q === 'calc') { showQ('fit'); return; }
      showQ(Q_ORDER[Math.max(0, Q_ORDER.indexOf(q) - 1)]);
    }
    $('[data-back-top]').addEventListener('click', goBack);
    function showQ(name) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-wq]'), function (q) { q.classList.toggle('is-active', q.getAttribute('data-wq') === name); });
      if (name === 'result') {
        var r = recommend();
        $('[data-reco-size]').textContent = r;
        var why = [];
        if (finder.fit === 'relaxed') why.push('הוספנו מידה כי את אוהבת גזרה משוחררת');
        if ((finder.month || 0) >= 8 && finder.fit !== 'close') why.push('הוספנו מידה לחודשים האחרונים');
        if (r === finder.usual) why.push('המידה הרגילה שלך מתאימה לכל הפריטים שלנו');
        $('[data-reco-why]').textContent = why.join(' · ');
        setSize(r);

      }
      track('size:' + name);
    }
    function pickChip(container, btn) { Array.prototype.forEach.call(container.children, function (c) { c.classList.toggle('is-selected', c === btn); }); }
    sizes.forEach(function (s) {
      var u = el('button', null, s); u.type = 'button';
      u.addEventListener('click', function () { finder.usual = s; pickChip(usualEl, u); enterFlow(); setTimeout(function () { showQ('month'); }, 180); });
      if (finder.usual === s) u.classList.add('is-selected');
      usualEl.appendChild(u);
      var b = el('button', null, s); b.type = 'button';
      b.addEventListener('click', function () { clearTimeout(state.autoNext); setSize(s); $('[data-reco-size]').textContent = s; $('[data-reco-why]').textContent = 'בחרת בעצמך'; });
      sizesEl.appendChild(b);
    });
    Array.prototype.forEach.call(monthChips.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () { finder.month = Number(b.getAttribute('data-value')); pickChip(monthChips, b); setTimeout(function () { showQ('fit'); }, 180); });
    });
    Array.prototype.forEach.call(fitEl.querySelectorAll('button'), function (b) {
      b.addEventListener('click', function () { finder.fit = b.getAttribute('data-value'); pickChip(fitEl, b); setTimeout(function () { showQ('calc'); }, 200); setTimeout(function () { showQ('result'); }, 1300); });
    });
    $('[data-wiz-continue]').addEventListener('click', function () { clearTimeout(state.autoNext); show(1); });
    $('[data-size-change]').addEventListener('click', function () { show(0, { noScroll: false }); showQ('result'); clearTimeout(state.autoNext); });
    $('[data-wiz-restart]').addEventListener('click', function () { finder = { usual: null, month: null, fit: null }; state.size = null; [usualEl, monthChips, fitEl].forEach(function (c) { pickChip(c, null); }); showQ('usual'); sync(); });

    // ---- render: product cards --------------------------------------------------------------
    function card(p, opts) {
      var c = el('button', 'bm__card'); c.type = 'button'; c.setAttribute('data-pid', String(p.id));
      var img = el('img'); img.alt = p.title; img.decoding = 'async'; img.src = p.image; c.appendChild(img);
      c.appendChild(el('span', 'bm__card__check', '✓'));
      if (opts.gift) c.appendChild(el('span', 'bm__card__gift', 'במתנה'));
      c.appendChild(el('strong', null, p.title));
      var price = el('div', 'bm__price');
      if (opts.gift) { var s = el('s', null, money(p.price)); price.appendChild(s); price.appendChild(el('em', null, '₪0')); }
      else price.appendChild(el('span', null, money(p.price)));
      c.appendChild(price);
      var cols = colorsOf(p);
      if (cols.length) {
        var sw = el('div', 'bm__swatches'); sw.setAttribute('data-swatches', '1');
        cols.forEach(function (col) {
          var b = el('button', SWATCH[col] ? 'bm__swatch' : 'bm__swatch bm__swatch--text', SWATCH[col] ? '' : col); b.type = 'button'; b.title = col; b.setAttribute('aria-label', col); b.setAttribute('data-color', col);
          if (SWATCH[col]) b.style.setProperty('--sw', SWATCH[col]);
          b.addEventListener('click', function (ev) { ev.stopPropagation(); opts.onColor(p, col); });
          sw.appendChild(b);
        });
        c.appendChild(sw);
      }
      c.addEventListener('click', function () { opts.onPick(p); });
      return c;
    }
    function renderGrid() {
      grid.innerHTML = '';
      products.forEach(function (p) {
        var c = card(p, {
          onPick: function (prod) {
            var i = state.picks.findIndex(function (pk) { return pk.product.id === prod.id; });
            if (i > -1) { state.picks.splice(i, 1); }
            else {
              if (!anyVariantForSize(prod, state.size)) return;
              if (state.picks.length >= 2) state.picks.shift();
              state.picks.push({ product: prod, color: firstColorFor(prod, state.size) });
            }
            if (state.gift && !giftEligible(state.gift.product)) state.gift = null;
            sync();
          },
          onColor: function (prod, col) {
            var pk = state.picks.find(function (x) { return x.product.id === prod.id; });
            if (!pk) { if (!anyVariantForSize(prod, state.size)) return; if (state.picks.length >= 2) state.picks.shift(); pk = { product: prod, color: col }; state.picks.push(pk); }
            if (variantFor(prod, col, state.size)) pk.color = col;
            sync();
          }
        });
        grid.appendChild(c);
      });
    }
    function renderGiftGrid() {
      giftGrid.innerHTML = '';
      products.filter(giftEligible).forEach(function (p) {
        giftGrid.appendChild(card(p, {
          gift: true,
          onPick: function (prod) { state.gift = { product: prod, color: firstColorFor(prod, state.size) }; sync(); },
          onColor: function (prod, col) { if (!state.gift || state.gift.product.id !== prod.id) state.gift = { product: prod, color: col }; else if (variantFor(prod, col, state.size)) state.gift.color = col; sync(); }
        }));
      });
      if (!giftGrid.children.length) giftGrid.appendChild(el('p', null, 'אין כרגע פריט במחיר מתאים למתנה במידה הזו. חזרי ובחרי פריטים אחרים.'));
    }
    function paintCards(container, selectedIds, colorFor) {
      Array.prototype.forEach.call(container.querySelectorAll('.bm__card'), function (c) {
        var pid = Number(c.getAttribute('data-pid')); var p = products.find(function (x) { return x.id === pid; });
        var sel = selectedIds.indexOf(pid) > -1;
        c.classList.toggle('is-selected', sel);
        var na = !anyVariantForSize(p, state.size);
        c.classList.toggle('is-dim', na);
        var naEl = c.querySelector('.bm__card__na');
        if (na && !naEl) { naEl = el('span', 'bm__card__na', 'לא זמין במידה ' + state.size); c.appendChild(naEl); } else if (!na && naEl) naEl.remove();
        var col = colorFor(pid);
        Array.prototype.forEach.call(c.querySelectorAll('[data-color]'), function (b) { b.classList.toggle('is-selected', sel && b.getAttribute('data-color') === col); });
        if (sel && col) { var v = variantFor(p, col, state.size); if (v && v.image) c.querySelector('img').src = v.image; }
      });
    }

    // ---- tray + totals -----------------------------------------------------------------------
    function fillSlot(slot, pick, isGift) {
      slot.innerHTML = '';
      if (!pick) { slot.classList.remove('is-filled'); slot.appendChild(el('span', 'bm__slot-ph', isGift ? 'המתנה' : slot.getAttribute('data-slot') === '0' ? 'פריט 1' : 'פריט 2')); return; }
      slot.classList.add('is-filled');
      var img = el('img'); img.src = imageOf(pick); img.alt = ''; slot.appendChild(img);
      var t = el('div'); t.appendChild(el('strong', null, pick.product.title));
      t.appendChild(el('small', null, [pick.color, state.size].filter(Boolean).join(' · ')));
      if (isGift) t.appendChild(el('em', null, 'במתנה · ₪0')); else t.appendChild(el('small', null, money(priceOf(pick))));
      slot.appendChild(t);
    }
    function sync() {
      fillSlot($('[data-slot="0"]'), state.picks[0], false);
      fillSlot($('[data-slot="1"]'), state.picks[1], false);
      fillSlot($('[data-slot="gift"]'), state.gift, true);
      var totals = $('[data-totals]');
      if (state.picks.length === 2) {
        var pay = state.picks.reduce(function (a, pk) { return a + priceOf(pk); }, 0);
        var cmp = pay + (state.gift ? priceOf(state.gift) : 0);
        totals.hidden = !state.gift;
        $('[data-total-compare]').textContent = money(cmp); $('[data-total-pay]').textContent = money(pay); $('[data-total-save]').textContent = money(cmp - pay);
      } else totals.hidden = true;
      $('[data-pick-count]').textContent = state.picks.length + '/2';
      var chip = $('[data-size-chip]'); if (chip) chip.textContent = state.size || '';
      paintCards(grid, state.picks.map(function (pk) { return pk.product.id; }), function (pid) { var pk = state.picks.find(function (x) { return x.product.id === pid; }); return pk ? pk.color : ''; });
      paintCards(giftGrid, state.gift ? [state.gift.product.id] : [], function () { return state.gift ? state.gift.color : ''; });
      // one action per step, with the running total next to it
      var pay = state.picks.reduce(function (a, pk) { return a + priceOf(pk); }, 0);
      var cmp = pay + (state.gift ? priceOf(state.gift) : 0);
      if (state.step === 1) {
        actionEl.hidden = false; nextBtn.disabled = state.picks.length !== 2; nextBtn.textContent = state.picks.length === 2 ? 'לבחירת המתנה' : 'בחרי עוד ' + (2 - state.picks.length) + (state.picks.length === 1 ? ' פריט' : ' פריטים');
        actionSum.innerHTML = state.picks.length ? '<b>' + money(pay) + '</b><span>' + state.picks.length + ' פריטים</span>' : '';
      } else if (state.step === 2) {
        actionEl.hidden = false; nextBtn.disabled = !state.gift; nextBtn.textContent = state.gift ? 'הוסיפי לסל' : 'בחרי מתנה';
        actionSum.innerHTML = state.gift ? '<b>' + money(pay) + '</b><s>' + money(cmp) + '</s><span>חסכת ' + money(cmp - pay) + '</span>' : '<b>' + money(pay) + '</b><span>2 פריטים</span>';
      } else actionEl.hidden = true;
    }

    // ---- steps ----------------------------------------------------------------------------------
    function show(i, opts) {
      opts = opts || {};
      state.step = i; box.classList.toggle('is-first', i === 0);
      Array.prototype.forEach.call(root.querySelectorAll('[data-step]'), function (s) { s.classList.toggle('is-active', s.getAttribute('data-step') === steps[i]); });
      $('[data-progress-label]').textContent = (i + 1) + ' / 3';
      $('[data-progress-bar]').style.width = Math.round(((i + 1) / 3) * 100) + '%';
      clearTimeout(state.autoAdd); if (addingEl) addingEl.hidden = true;
      if (steps[i] === 'pick') renderGrid();
      if (steps[i] === 'gift') { renderGiftGrid(); var gb = $('[data-giftbox]'); gb.classList.remove('is-open'); setTimeout(function () { gb.classList.add('is-open'); }, 150); }
      sync();
      if (!opts.noScroll && root.classList.contains('is-in')) window.scrollTo({ top: Math.max(0, box.getBoundingClientRect().top + window.pageYOffset - 12), behavior: 'smooth' });
      track(steps[i]);
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-start]'), function (b) {
      b.addEventListener('click', function () { box.hidden = false; show(0); });
    });
    // hero visual: three real products from the catalogue (dearest two + a gift that qualifies), live prices
    (function heroVisual() {
      var hv = $('[data-hero-visual]'); if (!hv) return;
      var sorted = products.slice().sort(function (a, b) { return b.price - a.price; });
      var a = sorted[0], b2 = sorted[1] || sorted[0];
      var gift = sorted.filter(function (p) { return p.price <= Math.min(a.price, b2.price) && p !== a && p !== b2; })[0] || sorted[sorted.length - 1];
      [a, b2, gift].forEach(function (p, i) { var f = hv.querySelector('[data-hv="' + i + '"]'); if (!f || !p) return; f.querySelector('img').src = p.image; if (i < 2) f.querySelector('figcaption').textContent = money(p.price); });
      var save = $('[data-hero-save]'); if (save) { save.querySelector('b').textContent = money(gift.price); save.hidden = false; }
    })();
    nextBtn.addEventListener('click', function () { if (state.step === 1) show(2); else if (state.step === 2) addCombo(); });

    // ---- add to cart (same guarantees as the product widget) -------------------------------------
    function post(url, body) { return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) }); }
    function applyCode() {
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        var existing = (cart.discount_codes || []).filter(function (c) { return c.applicable; }).map(function (c) { return c.code; });
        if (existing.indexOf(code) < 0) existing.push(code);
        return post('/cart/update.js', { discount: existing.join(',') }).then(function (r) { return r.ok ? r.json() : null; })
          .then(function (u) { return u || post('/cart/update.js', { discount: code }).then(function (r) { return r.ok ? r.json() : null; }); })
          .then(function (u) { return !!(u && (u.discount_codes || []).some(function (c) { return c.code === code && c.applicable; })); });
      }).catch(function () { return false; });
    }
    function undo(added) {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        return added.reduce(function (p, it) { return p.then(function () {
          var line = (cart.items || []).find(function (l) { return l.key === it.key; }); if (!line) return null;
          return post('/cart/change.js', { id: it.key, quantity: Math.max(0, line.quantity - it.quantity) });
        }); }, Promise.resolve());
      }).catch(function () {});
    }
    function openDrawer(added) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || typeof drawer.getSectionsToRender !== 'function') { window.location.href = '/cart'; return; }
      var ids = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      return fetch('/cart?sections=' + encodeURIComponent(ids) + '&t=' + Date.now()).then(function (r) { return r.json(); })
        .then(function (sections) { var f = added[0]; drawer.renderContents({ items: added, key: f && f.key, id: f && f.id, sections: sections }); })
        .catch(function () { window.location.href = '/cart'; });
    }
    function addCombo() {
      if (!state.gift || state.picks.length !== 2) return;
      var picks = state.picks.concat([state.gift]);
      var items = picks.map(function (pk, i) { var v = variantFor(pk.product, pk.color, pk.size || state.size); return v ? { id: v.id, quantity: 1, properties: { _bloom_more: i === 2 ? 'gift' : 'item' } } : null; });
      if (items.some(function (x) { return !x; })) { errEl.textContent = 'אחד הפריטים לא זמין במידה שנבחרה.'; errEl.hidden = false; return; }
      errEl.hidden = true; if (addingEl) addingEl.hidden = false; giftGrid.classList.add('is-busy');
      track('add_to_cart');
      post('/cart/add.js', { items: items }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); }).then(function (r) {
        if (!r.ok) throw new Error((r.body && (r.body.description || r.body.message)) || 'error');
        var added = (r.body.items || []).map(function (l) { return { key: l.key, id: l.id, quantity: l.quantity }; });
        return applyCode().then(function (ok) {
          if (!ok) return undo(added).then(function () { throw new Error('לא הצלחנו להחיל את המתנה בקופה. נסי שוב או פני אלינו.'); });
          if (addingEl) addingEl.hidden = true; giftGrid.classList.remove('is-busy');
          return openDrawer(added);
        });
      }).catch(function (e) { if (addingEl) addingEl.hidden = true; giftGrid.classList.remove('is-busy'); errEl.textContent = (e && e.message) || 'משהו השתבש, נסי שוב.'; errEl.hidden = false; });
    }

    function track(step) {
      try { window.dispatchEvent(new CustomEvent('bloom:more', { detail: { step: step, size: state.size, picks: state.picks.map(function (p) { return p.product.id; }), gift: state.gift && state.gift.product.id } })); } catch (e) { /* ignore */ }
    }
    box.hidden = false; show(0, { noScroll: true }); showQ('usual');
    sync();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-bloom-more]'), function (r) { if (!r.__bm) { r.__bm = true; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
